// import { useState, useEffect, useMemo } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import api from "../api";
// import {
//   Home, LayoutDashboard, FileText, PenSquare, MessageCircle, Users, Settings,
//   Search, SlidersHorizontal, Plus, Phone, Mail, MoreVertical, ChevronLeft, ChevronRight, X,
// } from "lucide-react";

// const initials = (name) => (name?.[0] || "?").toUpperCase();
// const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" }) : "—");
// const fmtTime = (d) => (d ? new Date(d).toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit" }) : "");

// const AVATAR_COLORS = ["bg-blue-100 text-blue-700", "bg-green-100 text-green-700", "bg-violet-100 text-violet-700",
//   "bg-orange-100 text-orange-700", "bg-sky-100 text-sky-700", "bg-rose-100 text-rose-700"];
// const avatarColor = (name) => AVATAR_COLORS[(name?.charCodeAt(0) || 0) % AVATAR_COLORS.length];

// const navBase = [
//   { icon: LayoutDashboard, label: "Dashboard", to: "/admin/dashboard" },
//   { icon: FileText, label: "Requests", to: "/admin/requests" },
//   { icon: PenSquare, label: "Quotes", to: "/admin/quotes" },
//   { icon: MessageCircle, label: "Comments", to: "/admin/comments" },
//   { icon: Users, label: "Customers", to: "/admin/customers", active: true },
// ];

// const PAGE_SIZE = 10;
// const FILTERS = ["All", "With Open Requests", "No Open Requests"];

// export default function CustomersList() {
//   const navigate = useNavigate();
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [query, setQuery] = useState("");
//   const [filter, setFilter] = useState("All");
//   const [showFilterMenu, setShowFilterMenu] = useState(false);
//   const [page, setPage] = useState(1);
//   const [unreadTotal, setUnreadTotal] = useState(0);

//   const [showAdd, setShowAdd] = useState(false);
//   const [form, setForm] = useState({ name: "", email: "", mobile: "", abn: "" });
//   const [saving, setSaving] = useState(false);
//   const [createdInfo, setCreatedInfo] = useState(null);

//   const load = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const { data } = await api.get("/admin/customers");
//       setRows(Array.isArray(data) ? data : []);
//     } catch {
//       setError("Couldn't load customers.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { load(); }, []);

//   useEffect(() => {
//     api.get("/admin/conversations")
//       .then(({ data }) => setUnreadTotal((data || []).reduce((s, c) => s + (c.unreadCount || 0), 0)))
//       .catch(() => {});
//   }, []);

//   const filtered = useMemo(() => {
//     let list = rows;
//     if (filter === "With Open Requests") list = list.filter((r) => r.openRequests > 0);
//     else if (filter === "No Open Requests") list = list.filter((r) => r.openRequests === 0);

//     const q = query.trim().toLowerCase();
//     if (q) {
//       list = list.filter((r) =>
//         [r.name, r.email, r.mobile, r.abn].filter(Boolean).some((v) => v.toLowerCase().includes(q))
//       );
//     }
//     return list;
//   }, [rows, query, filter]);

//   useEffect(() => { setPage(1); }, [query, filter]);

//   const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
//   const pageRows = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

//   const submitAdd = async (e) => {
//     e.preventDefault();
//     if (!form.name.trim() || !form.email.trim()) return;
//     setSaving(true);
//     try {
//       const { data } = await api.post("/admin/customers", form);
//       setCreatedInfo({ email: data.user.email, tempPassword: data.tempPassword });
//       setForm({ name: "", email: "", mobile: "", abn: "" });
//       load();
//     } catch (err) {
//       alert(err?.response?.data?.message || "Could not create customer.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const closeAdd = () => {
//     setShowAdd(false);
//     setCreatedInfo(null);
//   };

//   return (
//     <div className="min-h-screen flex bg-slate-50">
//       {/* ---------- Sidebar ---------- */}
//       <aside className="w-64 shrink-0 bg-[#0b1220] text-slate-300 flex flex-col">
//         <div className="px-6 py-6">
//           <nav className="space-y-1">
//             {navBase.map((n) => (
//               <button key={n.label} onClick={() => navigate(n.to)}
//                 className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium ${
//                   n.active ? "bg-slate-800 text-white" : "text-slate-400 hover:bg-slate-800/60 hover:text-slate-200"
//                 }`}>
//                 <n.icon size={18} />
//                 <span className="flex-1 text-left">{n.label}</span>
//                 {n.label === "Comments" && unreadTotal > 0 && (
//                   <span className="bg-red-500 text-white text-[10px] font-bold rounded-full w-5 h-5 grid place-items-center">
//                     {unreadTotal}
//                   </span>
//                 )}
//               </button>
//             ))}
//           </nav>
//         </div>
//         <div className="mt-auto px-6 py-6">
//           <button onClick={() => navigate("/admin/settings")}
//             className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-400 hover:bg-slate-800/60 hover:text-slate-200">
//             <Settings size={18} /> Settings
//           </button>
//         </div>
//       </aside>

//       {/* ---------- Main ---------- */}
//       <main className="flex-1 p-8">
//         <div className="mb-6">
//           <h1 className="text-3xl font-extrabold text-slate-900">Customers</h1>
//           <div className="flex items-center gap-1.5 text-sm text-slate-400 mt-1">
//             <Home size={14} />
//             <Link to="/admin/dashboard" className="hover:text-slate-600">Dashboard</Link>
//             <span>›</span>
//             <span className="text-slate-500">Customers</span>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-sm">
//           {/* toolbar */}
//           <div className="flex items-center gap-3 p-5 border-b border-gray-100">
//             <div className="flex-1 flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 max-w-md">
//               <Search size={16} className="text-slate-400" />
//               <input
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 placeholder="Search by request ID, customer, vehicle, part..."
//                 className="flex-1 text-sm focus:outline-none placeholder:text-slate-400"
//               />
//             </div>

//             <div className="relative ml-auto">
//               <button
//                 onClick={() => setShowFilterMenu((s) => !s)}
//                 className="flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
//               >
//                 <SlidersHorizontal size={15} className="text-slate-400" />
//                 Filters
//               </button>
//               {showFilterMenu && (
//                 <div className="absolute right-0 mt-2 bg-white border border-gray-100 rounded-xl shadow-lg py-2 z-10 w-52">
//                   {FILTERS.map((f) => (
//                     <button
//                       key={f}
//                       onClick={() => { setFilter(f); setShowFilterMenu(false); }}
//                       className={`w-full text-left px-4 py-2 text-sm ${filter === f ? "font-bold text-slate-900 bg-slate-50" : "text-slate-600 hover:bg-slate-50"}`}
//                     >
//                       {f}
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <button
//               onClick={() => setShowAdd(true)}
//               className="flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white bg-teal-800 hover:bg-teal-900"
//             >
//               <Plus size={16} />
//               Add Customer
//             </button>
//           </div>

//           {/* table */}
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="bg-[#14123a] text-white text-xs uppercase tracking-wide">
//                   <th className="text-left font-semibold px-6 py-4">Customer</th>
//                   <th className="text-left font-semibold px-6 py-4">Contact</th>
//                   <th className="text-left font-semibold px-6 py-4">Email</th>
//                   <th className="text-right font-semibold px-6 py-4">Total Requests</th>
//                   <th className="text-right font-semibold px-6 py-4">Open Requests</th>
//                   <th className="text-left font-semibold px-6 py-4">Last Activity</th>
//                   <th className="text-left font-semibold px-6 py-4">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading && (
//                   <tr><td colSpan={7} className="text-center text-slate-400 py-12">Loading customers…</td></tr>
//                 )}
//                 {!loading && error && (
//                   <tr><td colSpan={7} className="text-center text-red-500 py-12">{error}</td></tr>
//                 )}
//                 {!loading && !error && pageRows.length === 0 && (
//                   <tr><td colSpan={7} className="text-center text-slate-400 py-12">No customers match your filters.</td></tr>
//                 )}
//                 {!loading && !error && pageRows.map((c) => (
//                   <tr key={c._id} className="border-b border-gray-100 last:border-0 hover:bg-slate-50">
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-3">
//                         <span className={`grid place-items-center w-9 h-9 rounded-full text-xs font-bold shrink-0 ${avatarColor(c.name)}`}>
//                           {initials(c.name)}
//                         </span>
//                         <div>
//                           <div className="font-bold text-slate-800">{c.name}</div>
//                           {c.abn && <div className="text-xs text-slate-400">ABN: {c.abn}</div>}
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-1.5 text-slate-600">
//                         <Phone size={13} className="text-slate-400" /> {c.mobile || "—"}
//                       </div>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-1.5 text-slate-600">
//                         <Mail size={13} className="text-slate-400" /> {c.email}
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 text-right font-bold text-slate-800">{c.totalRequests}</td>
//                     <td className="px-6 py-4 text-right">
//                       <span
//                         className={`inline-flex w-7 h-6 items-center justify-center rounded-md text-xs font-bold ${
//                           c.openRequests > 2
//                             ? "bg-red-100 text-red-600"
//                             : c.openRequests > 0
//                             ? "bg-orange-100 text-orange-600"
//                             : "bg-slate-100 text-slate-400"
//                         }`}
//                       >
//                         {c.openRequests}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div className="text-slate-700 font-semibold">{fmtDate(c.lastActivity)}</div>
//                       <div className="text-xs text-slate-400">{fmtTime(c.lastActivity)}</div>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div className="flex items-center gap-3">
//                         <button
//                           onClick={() => navigate(`/admin/customers/${c._id}`)}
//                           className="border border-blue-200 text-blue-700 rounded-lg px-3 py-1.5 text-xs font-semibold hover:bg-blue-50"
//                         >
//                           View Profile
//                         </button>
//                         <button className="text-slate-300 hover:text-slate-500"><MoreVertical size={16} /></button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* footer / pagination */}
//           <div className="flex items-center justify-between px-6 py-4">
//             <span className="text-sm text-slate-400">
//               {filtered.length === 0
//                 ? "No customers"
//                 : `Showing ${(page - 1) * PAGE_SIZE + 1} to ${Math.min(page * PAGE_SIZE, filtered.length)} of ${filtered.length} requests`}
//             </span>
//             <div className="flex items-center gap-1.5">
//               <button
//                 onClick={() => setPage((p) => Math.max(1, p - 1))}
//                 disabled={page === 1}
//                 className="w-8 h-8 grid place-items-center rounded-lg border border-gray-200 text-slate-400 disabled:opacity-40"
//               >
//                 <ChevronLeft size={15} />
//               </button>
//               {Array.from({ length: totalPages }, (_, i) => i + 1).slice(0, 5).map((n) => (
//                 <button
//                   key={n}
//                   onClick={() => setPage(n)}
//                   className={`w-8 h-8 grid place-items-center rounded-lg text-sm font-semibold ${
//                     n === page ? "bg-blue-700 text-white" : "text-slate-500 hover:bg-slate-50"
//                   }`}
//                 >
//                   {n}
//                 </button>
//               ))}
//               <button
//                 onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//                 disabled={page === totalPages}
//                 className="w-8 h-8 grid place-items-center rounded-lg border border-gray-200 text-slate-400 disabled:opacity-40"
//               >
//                 <ChevronRight size={15} />
//               </button>
//             </div>
//           </div>
//         </div>
//       </main>

//       {/* ---------- Add Customer modal ---------- */}
//       {showAdd && (
//         <div className="fixed inset-0 bg-black/40 grid place-items-center z-50 p-4">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h2 className="text-lg font-bold text-slate-800">
//                 {createdInfo ? "Customer created" : "Add Customer"}
//               </h2>
//               <button onClick={closeAdd} className="text-slate-400 hover:text-slate-600"><X size={18} /></button>
//             </div>

//             {createdInfo ? (
//               <div className="space-y-3">
//                 <p className="text-sm text-slate-600">
//                   Share these temporary sign-in details with <strong>{createdInfo.email}</strong>. They should change the password after logging in.
//                 </p>
//                 <div className="bg-slate-50 rounded-xl p-3 text-sm font-mono">
//                   <div>Email: {createdInfo.email}</div>
//                   <div>Temp password: {createdInfo.tempPassword}</div>
//                 </div>
//                 <button onClick={closeAdd} className="w-full bg-teal-800 text-white rounded-xl py-2.5 font-semibold hover:bg-teal-900">
//                   Done
//                 </button>
//               </div>
//             ) : (
//               <form onSubmit={submitAdd} className="space-y-3">
//                 <div>
//                   <label className="text-xs font-semibold text-slate-500">Name *</label>
//                   <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
//                     className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
//                 </div>
//                 <div>
//                   <label className="text-xs font-semibold text-slate-500">Email *</label>
//                   <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
//                     className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
//                 </div>
//                 <div>
//                   <label className="text-xs font-semibold text-slate-500">Mobile</label>
//                   <input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })}
//                     className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
//                 </div>
//                 <div>
//                   <label className="text-xs font-semibold text-slate-500">ABN</label>
//                   <input value={form.abn} onChange={(e) => setForm({ ...form, abn: e.target.value })}
//                     className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
//                 </div>
//                 <button type="submit" disabled={saving}
//                   className="w-full bg-teal-800 text-white rounded-xl py-2.5 font-semibold hover:bg-teal-900 disabled:opacity-60">
//                   {saving ? "Creating…" : "Create Customer"}
//                 </button>
//               </form>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useState, useEffect, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api";
import AdminLayout from "../components/AdminLayout";
import {
  Home, Search, SlidersHorizontal, Plus, Phone, Mail, MoreVertical, ChevronLeft, ChevronRight, X,
} from "lucide-react";

const initials = (name) => (name?.[0] || "?").toUpperCase();
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" }) : "—");
const fmtTime = (d) => (d ? new Date(d).toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit" }) : "");

const AVATAR_COLORS = ["bg-blue-100 text-blue-700", "bg-green-100 text-green-700", "bg-violet-100 text-violet-700",
  "bg-orange-100 text-orange-700", "bg-sky-100 text-sky-700", "bg-rose-100 text-rose-700"];
const avatarColor = (name) => AVATAR_COLORS[(name?.charCodeAt(0) || 0) % AVATAR_COLORS.length];

const PAGE_SIZE = 10;
const FILTERS = ["All", "With Open Requests", "No Open Requests"];

export default function CustomersList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("All");
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [page, setPage] = useState(1);

  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", mobile: "", abn: "" });
  const [saving, setSaving] = useState(false);
  const [createdInfo, setCreatedInfo] = useState(null);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/admin/customers");
      setRows(Array.isArray(data) ? data : []);
    } catch {
      setError("Couldn't load customers.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    let list = rows;
    if (filter === "With Open Requests") list = list.filter((r) => r.openRequests > 0);
    else if (filter === "No Open Requests") list = list.filter((r) => r.openRequests === 0);

    const q = query.trim().toLowerCase();
    if (q) {
      list = list.filter((r) =>
        [r.name, r.email, r.mobile, r.abn].filter(Boolean).some((v) => v.toLowerCase().includes(q))
      );
    }
    return list;
  }, [rows, query, filter]);

  useEffect(() => { setPage(1); }, [query, filter]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageRows = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const submitAdd = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) return;
    setSaving(true);
    try {
      const { data } = await api.post("/admin/customers", form);
      setCreatedInfo({ email: data.user.email, tempPassword: data.tempPassword });
      setForm({ name: "", email: "", mobile: "", abn: "" });
      load();
    } catch (err) {
      alert(err?.response?.data?.message || "Could not create customer.");
    } finally {
      setSaving(false);
    }
  };

  const closeAdd = () => {
    setShowAdd(false);
    setCreatedInfo(null);
  };

  return (
    <AdminLayout>
      <main className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-extrabold text-slate-900">Customers</h1>
          <div className="flex items-center gap-1.5 text-sm text-slate-400 mt-1">
            <Home size={14} />
            <Link to="/admin/dashboard" className="hover:text-slate-600">Dashboard</Link>
            <span>›</span>
            <span className="text-slate-500">Customers</span>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm">
          {/* toolbar */}
          <div className="flex items-center gap-3 p-5 border-b border-gray-100">
            <div className="flex-1 flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 max-w-md">
              <Search size={16} className="text-slate-400" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search by request ID, customer, vehicle, part..."
                className="flex-1 text-sm focus:outline-none placeholder:text-slate-400"
              />
            </div>

            <div className="relative ml-auto">
              <button
                onClick={() => setShowFilterMenu((s) => !s)}
                className="flex items-center gap-2 border border-gray-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              >
                <SlidersHorizontal size={15} className="text-slate-400" />
                Filters
              </button>
              {showFilterMenu && (
                <div className="absolute right-0 mt-2 bg-white border border-gray-100 rounded-xl shadow-lg py-2 z-10 w-52">
                  {FILTERS.map((f) => (
                    <button
                      key={f}
                      onClick={() => { setFilter(f); setShowFilterMenu(false); }}
                      className={`w-full text-left px-4 py-2 text-sm ${filter === f ? "font-bold text-slate-900 bg-slate-50" : "text-slate-600 hover:bg-slate-50"}`}
                    >
                      {f}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button
              onClick={() => setShowAdd(true)}
              className="flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white bg-teal-800 hover:bg-teal-900"
            >
              <Plus size={16} />
              Add Customer
            </button>
          </div>

          {/* table */}
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#14123a] text-white text-xs uppercase tracking-wide">
                  <th className="text-left font-semibold px-6 py-4">Customer</th>
                  <th className="text-left font-semibold px-6 py-4">Contact</th>
                  <th className="text-left font-semibold px-6 py-4">Email</th>
                  <th className="text-right font-semibold px-6 py-4">Total Requests</th>
                  <th className="text-right font-semibold px-6 py-4">Open Requests</th>
                  <th className="text-left font-semibold px-6 py-4">Last Activity</th>
                  <th className="text-left font-semibold px-6 py-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr><td colSpan={7} className="text-center text-slate-400 py-12">Loading customers…</td></tr>
                )}
                {!loading && error && (
                  <tr><td colSpan={7} className="text-center text-red-500 py-12">{error}</td></tr>
                )}
                {!loading && !error && pageRows.length === 0 && (
                  <tr><td colSpan={7} className="text-center text-slate-400 py-12">No customers match your filters.</td></tr>
                )}
                {!loading && !error && pageRows.map((c) => (
                  <tr key={c._id} className="border-b border-gray-100 last:border-0 hover:bg-slate-50">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <span className={`grid place-items-center w-9 h-9 rounded-full text-xs font-bold shrink-0 ${avatarColor(c.name)}`}>
                          {initials(c.name)}
                        </span>
                        <div>
                          <div className="font-bold text-slate-800">{c.name}</div>
                          {c.abn && <div className="text-xs text-slate-400">ABN: {c.abn}</div>}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-1.5 text-slate-600">
                        <Phone size={13} className="text-slate-400" /> {c.mobile || "—"}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-1.5 text-slate-600">
                        <Mail size={13} className="text-slate-400" /> {c.email}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-right font-bold text-slate-800">{c.totalRequests}</td>
                    <td className="px-6 py-4 text-right">
                      <span
                        className={`inline-flex w-7 h-6 items-center justify-center rounded-md text-xs font-bold ${c.openRequests > 2
                            ? "bg-red-100 text-red-600"
                            : c.openRequests > 0
                              ? "bg-orange-100 text-orange-600"
                              : "bg-slate-100 text-slate-400"
                          }`}
                      >
                        {c.openRequests}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-slate-700 font-semibold">{fmtDate(c.lastActivity)}</div>
                      <div className="text-xs text-slate-400">{fmtTime(c.lastActivity)}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <button
                          onClick={() => navigate(`/admin/customers/${c._id}`)}
                          className="border border-blue-200 text-blue-700 rounded-lg px-3 py-1.5 text-xs font-semibold hover:bg-blue-50"
                        >
                          View Profile
                        </button>
                        <button className="text-slate-300 hover:text-slate-500"><MoreVertical size={16} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* footer / pagination */}
          <div className="flex items-center justify-between px-6 py-4">
            <span className="text-sm text-slate-400">
              {filtered.length === 0
                ? "No customers"
                : `Showing ${(page - 1) * PAGE_SIZE + 1} to ${Math.min(page * PAGE_SIZE, filtered.length)} of ${filtered.length} requests`}
            </span>
            <div className="flex items-center gap-1.5">
              <button
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
                className="w-8 h-8 grid place-items-center rounded-lg border border-gray-200 text-slate-400 disabled:opacity-40"
              >
                <ChevronLeft size={15} />
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).slice(0, 5).map((n) => (
                <button
                  key={n}
                  onClick={() => setPage(n)}
                  className={`w-8 h-8 grid place-items-center rounded-lg text-sm font-semibold ${n === page ? "bg-blue-700 text-white" : "text-slate-500 hover:bg-slate-50"
                    }`}
                >
                  {n}
                </button>
              ))}
              <button
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
                className="w-8 h-8 grid place-items-center rounded-lg border border-gray-200 text-slate-400 disabled:opacity-40"
              >
                <ChevronRight size={15} />
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* ---------- Add Customer modal ---------- */}
      {showAdd && (
        <div className="fixed inset-0 bg-black/40 grid place-items-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-bold text-slate-800">
                {createdInfo ? "Customer created" : "Add Customer"}
              </h2>
              <button onClick={closeAdd} className="text-slate-400 hover:text-slate-600"><X size={18} /></button>
            </div>

            {createdInfo ? (
              <div className="space-y-3">
                <p className="text-sm text-slate-600">
                  Share these temporary sign-in details with <strong>{createdInfo.email}</strong>. They should change the password after logging in.
                </p>
                <div className="bg-slate-50 rounded-xl p-3 text-sm font-mono">
                  <div>Email: {createdInfo.email}</div>
                  <div>Temp password: {createdInfo.tempPassword}</div>
                </div>
                <button onClick={closeAdd} className="w-full bg-teal-800 text-white rounded-xl py-2.5 font-semibold hover:bg-teal-900">
                  Done
                </button>
              </div>
            ) : (
              <form onSubmit={submitAdd} className="space-y-3">
                <div>
                  <label className="text-xs font-semibold text-slate-500">Name *</label>
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="text-xs font-semibold text-slate-500">Email *</label>
                  <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="text-xs font-semibold text-slate-500">Mobile</label>
                  <input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })}
                    className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="text-xs font-semibold text-slate-500">ABN</label>
                  <input value={form.abn} onChange={(e) => setForm({ ...form, abn: e.target.value })}
                    className="w-full mt-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none" />
                </div>
                <button type="submit" disabled={saving}
                  className="w-full bg-teal-800 text-white rounded-xl py-2.5 font-semibold hover:bg-teal-900 disabled:opacity-60">
                  {saving ? "Creating…" : "Create Customer"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </AdminLayout>
  );
}